import PrasannPic from '../Images/ProfilePic.jpg'
const Header = () =>{
	return(
		<div className="myHeader container-fluid">
			<div className=" pt-3">
				<div className="row">
					<div className="col-5 col-md-3 headerBorder">
						<img className="profilePic" alt="profilePic" src={PrasannPic} />
					</div>
					<div className="col-7 col-md-9 headingName">
						<h1>Prasanna Nadapurohit</h1>
						<h4 className="pl-2">MERN-Stack Developer</h4>	
					</div>
				</div>
			</div>
		</div>
		)
}

export default Header;